'use client';

import { imagePathResolver, useClientConfig } from '@shared/utils';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { FALLBACK_OFFER_IMAGE } from '../../../Forms/Registration/components/OfferPrimary/constants';
import { SmallLogo } from '../../../Logos/Logos';

function LandingPodDescription({ title, description, expiresAt, image }: { title: string; description: string; expiresAt: string; image: { link: string; altText: string } }) {
  const config = useClientConfig();
  const t = useTranslations('offer-choice');
  return (
    <div className="flex flex-col md:justify-center h-full pt-10 pb-12 px-6 md:p-20 md:pr-15 bg-foreground dark:bg-container-base text-foreground-inverse dark:text-background-inverse">
      {/* Logo - Using Lottoland logo as per requirements */}
      <div className="mb-5 md:mb-8">
        <div className="relative w-12 h-10 md:w-16 md:h-13">
          <SmallLogo className="w-full h-full text-accent-green" />
        </div>
      </div>

      {/* Text Content */}
      <div className="my-2">
        <p className="paragraph-strong text-accent-green" data-testid="offer-title">
          {title}
        </p>
        <h5 className="md:heading-3" data-testid="offer-description">
          {description}
        </h5>

        <div className="inline-block mt-5 py-1 px-2 bg-background/10 dark:bg-foreground/10 rounded-md">
          <p className="paragraph-s-strong" data-testid="offer-valid-until" data-expiry-date={expiresAt}>
            {t('valid_until', { date: new Date(expiresAt) })}
          </p>
        </div>
      </div>

      {/* Image - hidden on mobile, only desktop image used */}
      <div className="hidden md:block relative max-w-132.5 w-full aspect-[530/280] rounded-2xl mt-10 md:mt-20 mx-auto">
        <Image
          src={image ? imagePathResolver(image.link, config.baseImgUrl) : FALLBACK_OFFER_IMAGE}
          alt={image?.altText ?? 'Offer choice image'}
          fill
          className="rounded-2xl object-cover"
          sizes="(max-width: 768px) 100vw, 530px"
          priority
        />
      </div>
    </div>
  );
}

export { LandingPodDescription };
